import posthog from "posthog-js";

export type PostHogEventProperties = {
  organisation_id?: string;
  organisation_slug?: string;
  exception_type?: string;
  path?: string;
  user_role?: string;
  [key: string]: unknown;
};

export function initPostHog(appName: string) {
  // Le bundler de Bun remplace `process.env.BUN_PUBLIC_X` par sa valeur — mais
  // UNIQUEMENT si X est définie au moment du bundle. Sinon il laisse
  // l'expression telle quelle et, dans un navigateur où `process` n'existe
  // pas, la lecture lève `ReferenceError: process is not defined` : l'app ne
  // monte pas du tout, faute d'une clé d'analytics optionnelle. `typeof` est
  // la seule forme sûre quand l'identifiant n'est pas déclaré.
  if (typeof process === "undefined" || !process.env) return;

  const apiKey = process.env.BUN_PUBLIC_POSTHOG_KEY;
  const host = process.env.BUN_PUBLIC_POSTHOG_HOST;
  if (!apiKey) return;

  // Opt-in : les événements ne partent que si la variable d'env l'active explicitement.
  if (process.env.BUN_PUBLIC_POSTHOG_ENABLED !== "true") return;

  // Skip en local : pas de remontée d'événements
  if (
    typeof window !== "undefined" &&
    /^(localhost|127\.0\.0\.1|\[::1\])$/.test(window.location.hostname)
  ) {
    return;
  }

  posthog.init(apiKey, {
    api_host: host ?? "https://eu.i.posthog.com",
    capture_exceptions: true,
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    disable_session_recording: true,
    person_profiles: "identified_only",
  });

  // Purge les super-props laissées par d'autres projets dans le même navigateur
  posthog.unregister("project");

  posthog.register({
    app: appName,
    projet: "CorailRH",
    git_repository: "new-evaluans",
    runtime: "browser",
    lang: typeof navigator !== "undefined" ? navigator.language : undefined,
  });
}

export function identifyPostHogUser(email: string) {
  posthog.identify(email, { email });
}

export { posthog };
